import { useRootStore } from "store";

export function useSetToast() {
  const rootStore = useRootStore();

  return rootStore.uiStore.setToast;
}
